
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'FinishingAndParkingBlock2',

    components: {
        Finishing: () => import('./components/FinishingAndParkingBlock2/Finishing'),
        Parking: () => import('./components/FinishingAndParkingBlock2/Parking'),
    },
});
